import React from 'react';

const EmailIcon = ({ className, fill }) => {
  return (
<svg 
 className={className} 
version="1.0" 
xmlns="http://www.w3.org/2000/svg"
 width="75.000000pt" 
 height="75.000000pt" 
 viewBox="0 0 75.000000 75.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,75.000000) scale(0.100000,-0.100000)"
fill="#E35F14" stroke="none">
<path d="M160 516 c0 -7 211 -161 218 -159 11 4 212 154 212 159 0 2 -97 4
-215 4 -118 0 -215 -2 -215 -4z m380 -14 c0 -10 -159 -128 -168 -125 -18 7
-162 118 -162 125 0 4 74 8 165 8 91 0 165 -4 165 -8z"/>
<path d="M130 371 l0 -141 245 0 245 0 0 141 c0 112 -3 139 -12 132 -137 -106
-227 -173 -233 -173 -6 0 -96 67 -232 173 -10 7 -13 -20 -13 -132z m136 18
l106 -80 26 17 c15 9 64 46 110 81 45 34 84 63 87 63 3 0 5 -52 5 -115 l0
-115 -225 0 -225 0 0 115 c0 63 2 115 5 115 3 0 52 -36 111 -81z"/>
</g>
</svg>
  )
}
export default EmailIcon;